/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_K_OfficialInputs */

const en_home_artcraft_k_official = /** @type {(inputs: Home_Artcraft_K_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official page`)
};

/**
* | output |
* | --- |
* | "Official page" |
*
* @param {Home_Artcraft_K_OfficialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_k_official = /** @type {((inputs?: Home_Artcraft_K_OfficialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_K_OfficialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_k_official(inputs)
});
export { home_artcraft_k_official as "home.artcraft.k_official" }